import React, { useEffect, useRef } from "react";
import ReactApexChart from "react-apexcharts";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import moment from "moment-timezone";

const priorityColors = {
  1: "red",
  2: "#FDE03A",
  3: "gray",
};

export default ({
  data,
  extra,
  brushScrolled,
  legendClick,
  entityList,
  findings,
  min,
  max,
}) => {
  // refs to control timeline chart
  const windowedRef = useRef();
  const fullRef = useRef();
  console.log(min, max, data);
  useEffect(() => {
    windowedRef.current.chart.data.w.config.series.forEach((series) => {
      // chart data length will be 0 if the series is disabled
      // if chart state does not match entityList state, toggle on chart to match entityList
      if (series.data.length > 0 === entityList[series.name].disabled) {
        if (windowedRef?.current?.chart) {
          windowedRef.current.chart.toggleSeries(series.name);
        }
        if (fullRef?.current?.chart) {
          fullRef.current.chart.toggleSeries(series.name);
        }
      }
    });
  }, [entityList]);

  const findingAnnotations = findings.map((f) => {
    return {
      x: new moment(f.created).unix() * 1000,
      strokeDashArray: 0,
      borderColor: priorityColors[f.priority],
      label: {
        borderColor: priorityColors[f.priority],
        style: {
          color: "#000",
          background: priorityColors[f.priority],
        },
        text: `P${f.priority}`,
      },
    };
  });

  const optionsLine = {
    chart: {
      id: "chart1",
      height: 130,
      type: "area",
      brush: {
        target: "chart2",
        enabled: true,
      },
      selection: {
        enabled: true,
        xaxis: {
          min: Number(min),
          max: Number(max),
        },
      },
      events: {
        brushScrolled,
      },
    },
    colors: ["#008FFB"],
    fill: {
      type: "gradient",
      gradient: {
        opacityFrom: 0.91,
        opacityTo: 0.1,
      },
    },
    xaxis: {
      type: "datetime",
      tooltip: {
        enabled: false,
      },
    },
    yaxis: {
      tickAmount: 2,
    },
    legend: {
      show: false,
    },
    annotations: {
      xaxis: findingAnnotations,
    },
  };

  const options = {
    chart: {
      id: "chart2",
      type: "line",
      height: 400,
      toolbar: {
        autoSelected: "pan",
        show: false,
      },
      events: {
        legendClick,
      },
    },
    //colors: ['#546E7A'],
    stroke: {
      width: 3,
    },
    dataLabels: {
      enabled: false,
    },
    fill: {
      opacity: 1,
    },
    markers: {
      size: 0,
    },
    xaxis: {
      type: "datetime",
    },
    extra,
    legend: {
      fontSize: "16px",
      fontWeight: 400,
      itemMargin: {
        horizontal: 15,
        vertical: 15,
      },
      formatter: (seriesName, opts) => {
        return `${seriesName} (${opts.w.config.extra[seriesName]})`;
      },
    },
    annotations: {
      xaxis: findingAnnotations,
    },
  };

  const setDays = (days) => {
    const min =
      new moment().startOf("day").subtract(days, "days").unix() * 1000;
    const max = new moment().unix() * 1000;
    brushScrolled(windowedRef, { xaxis: { min, max } }, false);
  };

  return (
    <div id="wrapper" style={{ textAlign: "center" }}>
      <div id="chart-line2">
        <ReactApexChart
          ref={windowedRef}
          options={options}
          series={data}
          type="line"
          height={400}
        />
      </div>
      <div id="chart-line">
        <ReactApexChart
          ref={fullRef}
          options={optionsLine}
          series={data}
          type="area"
          height={130}
        />
      </div>
      <ButtonGroup>
        <Button onClick={() => setDays(1)}>Past 24 hours</Button>
        <Button onClick={() => setDays(7)}>Past 7 days</Button>
        <Button onClick={() => setDays(30)}>Past 30 days</Button>
      </ButtonGroup>
    </div>
  );
};
